<template>
    <div name="page-footer" class="page-footer">
        <ul class="btn-group">
            <li>
                <a
                    href="https://soldoc.co.kr"
                    class="btn text-btn"
                    target="_blank"
                    title="새창으로 열림"
                >
                    솔닥소개
                </a>
            </li>
            <li>
                <a
                    href="https://policy.soldoc.co.kr/terms"
                    class="btn text-btn"
                    target="_blank"
                    title="새창으로 열림"
                >
                    이용약관
                </a>
            </li>
            <li>
                <a
                    href="https://policy.soldoc.co.kr/privacy"
                    class="btn text-btn"
                    target="_blank"
                    title="새창으로 열림"
                >
                    개인정보방침
                </a>
            </li>
            <li>
                <a
                    href="https://soldoc.co.kr/partners"
                    class="btn text-btn"
                    target="_blank"
                    title="새창으로 열림"
                >
                    제휴신청
                </a>
            </li>
            <li>
                <a
                    href="https://soldoc.co.kr/partners"
                    class="btn text-btn"
                    target="_blank"
                    title="새창으로 열림"
                >
                    B2B 제휴신청
                </a>
            </li>
        </ul>
        <div class="info-wrapper">
            <p class="info">
                <span
                    >회사명 : 솔닥 주식회사 | 대표 : 김민승 이호익 |
                    사업자등록번호 : 284-87-00967 | 통신판매업 신고번호 :
                    2021-서울강남-06329호</span
                >
                <span
                    >서울특별시 강남구 도산대로 174. 7층 (정안빌딩) | E-Mail :
                    info@soldoc.co.kr | 대표번호 : 02-6954-7676 | 개인정보관리자
                    : 김민승</span
                >
                <span class="copyright"
                    >COPYRIGHT ⓒsoldoc.co.kr All rights reserved.</span
                >
            </p>
        </div>
        <div class="sns-wrapper">
            <a
                href="http://pf.kakao.com/_xbzxhNxb"
                class="btn img-btn"
                target="_blank"
                title="새 창 열림"
            >
                <img src="../../assets/renew_pc/kakao_channel.png" alt="kakao channel" />
            </a>
            <a
                href="https://blog.naver.com/soldoc_ac"
                class="btn img-btn"
                target="_blank"
                title="새 창 열림"
            >
                <img src="../../assets/renew_pc/blog.png" alt="blog" />
            </a>
            <a
                href="https://www.youtube.com/channel/UCnXdyK6DZQ2sKvvlSonzXmA"
                class="btn img-btn"
                target="_blank"
                title="새 창 열림"
            >
                <img src="../../assets/renew_pc/youtube.png" alt="youtube" />
            </a>
            <a
                href="https://www.instagram.com/dr.soldoc/"
                class="btn img-btn"
                target="_blank"
                title="새 창 열림"
            >
                <img src="../../assets/renew_pc/insta.png" alt="instagram" />
            </a>
            <!-- <a
                href="https://post.naver.com/soldoc_ac"
                class="btn img-btn"
                target="_blank"
                title="새 창 열림"
            >
                <img src="../../assets/renew_pc/naver_post.png" alt="naver post" />
            </a> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "pageFooter",
    methods: {},
};
</script>

<style scoped>
.page-footer {
    min-width: 900px;
    height: 406px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding-top: 85px;
    background-color: #1a1a1a;
}
.page-footer .btn {
    padding: 0;
    color: #fff;
}

.btn-group {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 515px;
    margin: 0;
    padding: 0;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: -0.02em;
    color: #fff;
    list-style-type: none;
}
.btn-group li {
    flex: 0 0 auto;
    position: relative;
    padding-right: 18px;
}
.btn-group li:after {
    position: absolute;
    top: 50%;
    right: -1.5px;
    display: inline-block;
    transform: translateY(-50%);
    content: "|";
}
.btn-group li:last-child {
    padding-right: 0;
}
.btn-group li:last-child:after {
    content: none;
}

.text-btn:hover {
    text-decoration: none;
    color: #fff;
}
.text-btn {
    font-weight: 500;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: -0.02em;
    cursor: pointer;
}
.info-wrapper {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    font-family: "Pretendard";
    text-align: center;
    letter-spacing: -0.02em;
    color: #fff;
    margin-top: 17px;
}
.info-wrapper .info {
    width: 100%;
}
.info-wrapper .info span {
    display: block;
}
.info-wrapper .info .copyright {
    margin-top: 13px;
}
.sns-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-top: 17px;
}
.img-btn {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pc_main/PageFooter.vue